<template>
  <div>
    <h1>Your projects</h1>
    <v-layout v-if="l_projects" class="spacer_before" wrap row>
      <v-flex v-for="project in projects" :key="project.id" xs12 sm6 md4 lg3>
        <Project :id="parseInt(project.id)" :name="project.name" :description="project.description" />
      </v-flex>
      <v-flex xs12 sm6 md4 lg3 @click="d_create_project = true">
        <AddCard description="New project" />
      </v-flex>
    </v-layout>
    <div v-if="!l_projects">
      <Loading />
    </div>

    <!-- Dialog for creating new projects -->
    <v-dialog
      v-model="d_create_project"
      width="500"
    >
      <v-card>
        <v-form @submit="saveCreateProject">
          <v-card-title
            class="headline"
            primary-title
          >
            New project
          </v-card-title>

          <v-card-text>
            <v-text-field ref="new_project_name" v-model="f_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              type="submit"
              :loading="l_create_project"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Project from "../components/dashboard/Project";
import AddCard from "../components/general/AddCard";
import { Projects } from "../logic/Projects";
import { Notifications } from "../notification";

export default {
  name: "Dashboard",
  mounted(){
    this.loadProjects();
  },
  data(){
    return {
      projects: [],

      //Forms
      f_name: "",

      //Loading states
      l_projects: false,
      l_create_project: false,

      //Dialogs
      d_create_project: false
    }
  },
  methods: {
    async loadProjects(){
      var result = await Projects.load();

      if(result.status === 200){
        this.projects = result.body;
      } else if (result.status !== 404) { //If there are no projects yet, do not show a message
        Notifications.show(result.message);
      }

      this.l_projects = true;
    },
    saveCreateProject(e){
      e.preventDefault();

      var global_this = this;

      //Validation
      this.f_name = this.f_name.trim();
      Projects.create(this.f_name).then(function(response){
        if(response.status === 200){
          Notifications.show(response.message);
          global_this.d_create_project = false;

          //Load again projects
          global_this.loadProjects();
        } else {
          Notifications.show(response.message);
        }
      });
    }
  },
  components: {
    Project,
    AddCard
  },
  watch: {
    d_create_project(current){
      var global_this = this;
      if(current){
        setTimeout(function(){ global_this.$refs.new_project_name.focus(); }, 200);
      }
    }
  }
}
</script>
